export const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const assetUrls = [
  { id: 'url', label: 'Primary Asset' },
  { id: 'secondary_image_url', label: 'Secondary Image Asset' },
  { id: 'secondary_video_url', label: 'Secondary Video Asset' },
  { id: 'clickable_video_url', label: 'Clickable Video Asset' },
];

export const pageSizes = [5, 10, 20, 50];

export const statusVariants = {
  Error: 'danger',
  Unverified: 'secondary',
  'Verified - Impression': 'warning',
  Running: 'light',
  Pending: 'dark',
};

export const statusLabel = {
  Error: 'Error',
  Unverified: 'Unverified',
  'Verified - Impression': 'Impression Registered',
  'Verified - Click': 'Click Registered',
  Running: 'Running',
  Pending: 'Pending',
};

export const STATUS_LIST = [
  'Pending',
  'Running',
  'Unverified',
  'Verified - Click',
  'Verified - Impression',
  'Error',
];

export const verificationStatusList = [
  { title: 'Right CTA', variant: 'success' },
  { title: 'Wrong CTA', variant: 'danger' },
  { title: 'Failed Test', variant: 'dark' },
];
